/**
 * Stripe.js loader and configuration.
 */

import { loadStripe, Stripe } from "@stripe/stripe-js";

// Singleton promise for Stripe instance
let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Get the Stripe instance.
 * Returns a promise that resolves to the Stripe object.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

    if (!publishableKey) {
      console.error("Missing VITE_STRIPE_PUBLISHABLE_KEY environment variable");
      return Promise.resolve(null);
    }

    stripePromise = loadStripe(publishableKey);
  }

  return stripePromise;
}

// Boost pack pricing info (for display purposes)
export interface BoostPack {
  id: string;
  name: string;
  boosts: number;
  price: number; // in cents
  priceDisplay: string;
  popular?: boolean;
}

// @deprecated — The pricing page now fetches plans dynamically from Stripe.
// This array is still used by AutoTopUpSettings and BoostPurchaseModal.
// TODO: Migrate those components to use dynamic data, then remove it.
export const BOOST_PACKS: BoostPack[] = [
  {
    id: "price_1Su2cT4WsKqFBSd1uAhEIJti",
    name: "Small Pack",
    boosts: 500,
    price: 500,
    priceDisplay: "$5",
  },
  {
    id: "price_1Su2cU4WsKqFBSd1cYUM5TfF",
    name: "Medium Pack",
    boosts: 2000,
    price: 1500,
    priceDisplay: "$15",
    popular: true,
  },
  {
    id: "price_1Su2cU4WsKqFBSd1I0o0thQM",
    name: "Large Pack",
    boosts: 6000,
    price: 4000,
    priceDisplay: "$40",
  },
];

// Feature boost costs (for reference in UI)
export const FEATURE_COSTS: Record<string, number> = {
  basic_query: 1,
  advanced_analysis: 10,
  export_report: 5,
};
